var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AUTH_ACTIONS } from '../constants';
var actions = new Map([
    [
        AUTH_ACTIONS.SET_INVALID_DATA,
        function (data, payload) {
            return __assign(__assign({}, data), { invalid_data: payload });
        },
    ],
    [
        AUTH_ACTIONS.SET_USER_ID,
        function (data, payload) {
            return __assign(__assign({}, data), { user_id: payload });
        },
    ],
    [
        AUTH_ACTIONS.SET_INVALID_CODE,
        function (data, payload) {
            return __assign(__assign({}, data), { invalid_code: payload });
        },
    ],
    [
        AUTH_ACTIONS.SET_INVALID_EMAIL,
        function (data, payload) {
            return __assign(__assign({}, data), { invalid_email: payload });
        },
    ],
    [
        AUTH_ACTIONS.SET_EXISTED_USERNAME,
        function (data, payload) {
            return __assign(__assign({}, data), { existed_username: payload });
        },
    ],
    [
        AUTH_ACTIONS.SET_EXISTED_EMAIL,
        function (data, payload) {
            return __assign(__assign({}, data), { existed_email: payload });
        },
    ],
    [
        AUTH_ACTIONS.LOGOUT,
        function (data) {
            return __assign(__assign({}, data), { isAuth: false, user_id: '', user_role: '', invalid_code: false, existed_email: false, invalid_email: false, existed_username: false, invalid_data: false });
        },
    ],
    [
        AUTH_ACTIONS.SET_IS_AUTH,
        function (data, payload) {
            return __assign(__assign({}, data), { isAuth: payload });
        },
    ],
]);
export var authReducer = function (state, action) {
    if (actions.has(action.type)) {
        return __assign(__assign({}, state), { data: actions.get(action.type)(state.data, action.payload) });
    }
    else {
        return state;
    }
};
